import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import { url } from '../../../js/api/endpoint';
import user from '../../../js/stores/user.js';
import themes from '../../../js/stores/theme.js';
import language from '../../../js/stores/language.js';
import carLoan from '../../../js/stores/car-loan.js';
import file from '../../../js/stores/file.js';
import { FileUploadWithPreview } from 'file-upload-with-preview';
var MeetingTab = function MeetingTab(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $onBeforeUnmount = _ref.$onBeforeUnmount;
  var locale = language.getters.Item.value;
  var data = props.data;
  var cfg = props.config;
  var isOwner = user.getters.carId.value == props.data.CarMainData.CarId ? true : false;
  var isBorrower = user.getters.carId.value != props.data.CarMainData.CarId ? true : false;
  var isDisabled = true;
  var uploadCarLoanImageList = null;
  var uploadLoanDriverImageList = null;
  var currentFuelLevel = props.config.currentFuelLevel;
  var currentKilometers = props.config.currentKilometers;
  var fuelSlider = null;
  var fuelGauge = null;
  var fuelValue = {
    0: locale.translate('general.empty'),
    12.5: '1/8',
    25: '1/4',
    37.5: '3/8',
    50: '1/2',
    62.5: '5/8',
    75: '3/4',
    87.5: '7/8',
    100: locale.translate('general.full')
  };
  var loanImageList = [];
  var loanPhotoBrowser = [];
  var loanStoreFilesEvents = cfg.filesEvents; //[ 'getLoanCarImages', 'getLoanDriverImages' ]; || [ 'getReturnLoanCarImages', 'getReturnLoanDriverImages' ]

  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var i, loanPhotoList, j, urlFile;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (props.data.CarLoanData.CarLoanStatusId == 4 && isOwner) {
            isDisabled = false;
          }
          if (props.data.CarLoanData.CarLoanStatusId == 6 && isBorrower) {
            isDisabled = false;
          }
          if (!(props.data.CarLoanData.CarLoanStatusId > cfg.currentLoanStatusId)) {
            _context.next = 4;
            break;
          }
          i = 0;
        case 1:
          if (!(i < loanStoreFilesEvents.length)) {
            _context.next = 4;
            break;
          }
          _context.next = 2;
          return file.dispatch(loanStoreFilesEvents[i], props.data.CarLoanData.CarLoanId);
        case 2:
          loanPhotoList = _context.sent;
          loanImageList = [];
          for (j = 0; j < loanPhotoList.length; j++) {
            if (!(loanPhotoList[j].FilePath.length == 0 && loanPhotoList[j].FileName.length == 0)) {
              urlFile = "".concat(url, "/").concat(loanPhotoList[j].FilePath, "/").concat(loanPhotoList[j].FileName);
              loanImageList.push(urlFile);
            }
          }
          if (loanImageList.length > 0) {
            loanPhotoBrowser[i] = $f7.photoBrowser.create({
              photos: loanImageList,
              theme: themes.getters.Name.value
            });
          }
        case 3:
          i++;
          _context.next = 1;
          break;
        case 4:
          setTimeout(function () {
            configFileUploaders();
          }, 250);
          $update();
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var openLoanCarImages = function openLoanCarImages() {
    loanPhotoBrowser[0].open();
  };
  var openLoanDriverImages = function openLoanDriverImages() {
    loanPhotoBrowser[1].open();
  };
  $onBeforeUnmount(function () {
    if (fuelGauge != null) {
      fuelGauge.destroy();
    }
  });
  var configFileUploaders = function configFileUploaders() {
    if (!isDisabled && props.data.CarLoanData.CarLoanStatusId == cfg.currentLoanStatusId) {
      uploadCarLoanImageList = new FileUploadWithPreview("".concat(cfg.prefix, "-car-data-images"), {
        maxFileCount: 8,
        multiple: true,
        accept: 'image/jpeg,image/jpg',
        text: {
          label: locale.translate('loan.meeting.uploadCarLoanImagesLabel'),
          browse: locale.translate('general.browse'),
          chooseFile: locale.translate('general.chooseFileLabel'),
          selectedCount: locale.translate('general.selectedCountLabel')
        }
      });
      uploadLoanDriverImageList = new FileUploadWithPreview("".concat(cfg.prefix, "-driver-data-images"), {
        maxFileCount: 7,
        multiple: true,
        accept: 'image/jpeg,image/jpg',
        text: {
          label: locale.translate('loan.meeting.uploadDriverImagesLabel'),
          browse: locale.translate('general.browse'),
          chooseFile: locale.translate('general.chooseFileLabel'),
          selectedCount: locale.translate('general.selectedCountLabel')
        }
      });
    }
    fuelSlider = $f7.range.create({
      el: ".range-slider-".concat(cfg.prefix),
      min: 0,
      max: 100,
      label: true,
      step: 12.5,
      value: currentFuelLevel,
      scale: true,
      scaleSteps: 8,
      formatLabel: function formatLabel(value) {
        return fuelValue[value];
      },
      formatScaleLabel: function formatScaleLabel(value) {
        return fuelValue[value];
      }
    });
    fuelGauge = $f7.gauge.create({
      el: "#gauge-fuel-".concat(cfg.prefix),
      type: 'semicircle',
      value: currentFuelLevel > 0 ? currentFuelLevel / 100 : 0,
      valueText: fuelValue[parseFloat(currentFuelLevel)],
      valueTextColor: '#009688',
      borderColor: '#009688'
    });
    if (props.data.CarLoanData.CarLoanStatusId == 6 && isBorrower) {
      document.getElementById("current-meeting-form").classList.add('disabled');
    }
  };
  var onFuelChange = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var gauge, labelTank;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            gauge = $f7.gauge.get("#gauge-fuel-".concat(cfg.prefix));
            labelTank = fuelValue[e.detail];
            gauge.update({
              value: e.detail / 100,
              valueText: labelTank
            });
            currentFuelLevel = e.detail;
            $update();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onFuelChange(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var saveCarLoanImageList = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var totalCarLoanFiles, totalDriverFiles, _t;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            totalCarLoanFiles = uploadCarLoanImageList.cachedFileArray.length;
            totalDriverFiles = uploadLoanDriverImageList.cachedFileArray.length;
            if (!(totalCarLoanFiles < 8)) {
              _context4.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('general.uploadListLimitMessage', [8])
            });
            return _context4.abrupt("return");
          case 1:
            if (!(totalDriverFiles < 2)) {
              _context4.next = 2;
              break;
            }
            $f7.toast.show({
              text: locale.translate('general.uploadListLimitMessage', [2])
            });
            return _context4.abrupt("return");
          case 2:
            if (!(currentFuelLevel == "" || currentFuelLevel < 1)) {
              _context4.next = 3;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.meeting.emptyTank')
            });
            return _context4.abrupt("return");
          case 3:
            if (!(currentKilometers == "" || currentKilometers < 1)) {
              _context4.next = 4;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.meeting.kilometersBelowOne')
            });
            return _context4.abrupt("return");
          case 4:
            $f7.dialog.confirm(locale.translate("loan.meeting.".concat(cfg.confirmMessage)), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var formLoadCarImageData, i, resultCarImages, formLoanDriverImageData, _i, resultDriverImages, formLoanData, resultForLoan;
              return _regeneratorRuntime.wrap(function (_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    $f7.preloader.show();
                    formLoadCarImageData = new FormData();
                    formLoadCarImageData.append('ReferenceId', data.CarLoanData.CarLoanId);
                    formLoadCarImageData.append("LenderId", data.CarMainData.ContactId);
                    formLoadCarImageData.append("BorrowerId", data.CarLoanData.BorrowerId);
                    for (i = 0; i < totalCarLoanFiles; i++) {
                      formLoadCarImageData.append("".concat(cfg.loanCarTag, "[").concat(i, "]"), uploadCarLoanImageList.cachedFileArray[i]); //loan-car ||return-car
                    }
                    _context3.next = 1;
                    return file.dispatch("".concat(cfg.uploadLoadCarImagesEvent), formLoadCarImageData);
                  case 1:
                    resultCarImages = _context3.sent;
                    if (!(resultCarImages.status !== undefined && resultCarImages.status !== 201)) {
                      _context3.next = 2;
                      break;
                    }
                    $f7.preloader.hide();
                    $f7.toast.show({
                      text: resultCarImages.data.messages.error
                    });
                    return _context3.abrupt("return");
                  case 2:
                    formLoanDriverImageData = new FormData();
                    formLoanDriverImageData.append('ReferenceId', data.CarLoanData.CarLoanId);
                    formLoanDriverImageData.append("LenderId", data.CarMainData.ContactId);
                    formLoanDriverImageData.append("BorrowerId", data.CarLoanData.BorrowerId);
                    for (_i = 0; _i < totalDriverFiles; _i++) {
                      formLoanDriverImageData.append("".concat(cfg.loanDriverTag, "[").concat(_i, "]"), uploadLoanDriverImageList.cachedFileArray[_i]); //loan-driver || return-driver
                    }
                    _context3.next = 3;
                    return file.dispatch("".concat(cfg.uploadLoadDriverImagesEvent), formLoanDriverImageData);
                  case 3:
                    resultDriverImages = _context3.sent;
                    if (!(resultDriverImages.status !== undefined && resultDriverImages.status !== 201)) {
                      _context3.next = 4;
                      break;
                    }
                    $f7.preloader.hide();
                    $f7.toast.show({
                      text: resultDriverImages.data.messages.error
                    });
                    return _context3.abrupt("return");
                  case 4:
                    formLoanData = new FormData();
                    formLoanData.append("CarLoanId", data.CarLoanData.CarLoanId);
                    formLoanData.append("CarId", data.CarMainData.CarId);
                    formLoanData.append("LenderId", data.CarMainData.ContactId);
                    formLoanData.append("BorrowerId", data.CarLoanData.BorrowerId);
                    formLoanData.append("".concat(cfg.upperSuffix, "FuelLevel"), currentFuelLevel);
                    formLoanData.append("".concat(cfg.upperSuffix, "Kilometers"), currentKilometers);
                    _context3.next = 5;
                    return carLoan.dispatch("".concat(cfg.saveEvent), formLoanData);
                  case 5:
                    resultForLoan = _context3.sent;
                    if (!(resultForLoan.status !== undefined && resultForLoan.status !== 200)) {
                      _context3.next = 6;
                      break;
                    }
                    $f7.preloader.hide();
                    $f7.toast.show({
                      text: resultForLoan.data.messages.error
                    });
                    return _context3.abrupt("return");
                  case 6:
                    $f7.preloader.hide();
                    $f7.toast.show({
                      text: locale.translate('car.edit.carImageListUploadedOkMessage')
                    });
                    $f7.views.main.router.navigate('/', {
                      reloadCurrent: true,
                      ignoreCache: true
                    });
                  case 7:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            })));
            _context4.next = 6;
            break;
          case 5:
            _context4.prev = 5;
            _t = _context4["catch"](0);
            $f7.preloader.hide();
            console.error(_t);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 5]]);
    }));
    return function saveCarLoanImageList() {
      return _ref4.apply(this, arguments);
    };
  }();
  var updateKilometers = function updateKilometers(e) {
    currentKilometers = e.target.value;
    $update();
  };
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page-content tab" id="${cfg.tabId}">
  <div class="block">
    ${props.data.CarLoanData.CarLoanStatusId > cfg.currentLoanStatusId ? $h`
    <div class="block block-strong">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div>
          <a href="#" class="button button-small button-fill button-raised color-green" @click="${openLoanCarImages}">
            <span class="material-symbols-outlined">photo_camera</span> ${locale.translate('loan.meeting.showCarImageLabel')}
          </a>
        </div>
        <div></div>
        <div>
          <a href="#" class="button button-small button-fill button-raised color-blue" @click="${openLoanDriverImages}">
            <span class="material-symbols-outlined">photo_camera</span> ${locale.translate('loan.meeting.showDriverImageLabel')}
          </a>
        </div>
      </p>
    </div>
    ` : $h`
    <span></span>
    `}
    ${!isDisabled && props.data.CarLoanData.CarLoanStatusId == cfg.currentLoanStatusId ? $h`
    <div id="${cfg.prefix}-file-car-images" class="custom-file-container list block text-align-center" data-upload-id="${cfg.prefix}-car-data-images"></div>
    <div id="${cfg.prefix}-file-driver-images" class="custom-file-container list block text-align-center" data-upload-id="${cfg.prefix}-driver-data-images"></div>
    ` : $h`
    <span></span>
    `}
    <form id="${cfg.prefix}-meeting-form" class="list no-hairlines-md ${isDisabled ? $h`disabled` : $h``}">
      <!-- Range Slider element -->
      <div class="block-title">${locale.translate('loan.meeting.currentFuelLevel')}</div>
      <div class="list list-strong-ios list-outline-ios simple-list text-align-center" style="width: 95%; margin: 0 16px">
        <div style="width: 100%; margin: 0 16px">
          <div class="range-slider-${cfg.prefix}" @range:changed=${onFuelChange}></div>
        </div>
      </div>
      <br />
      <div class="text-align-center">
        <i class="icon material-symbols-outlined color-teal">local_gas_station</i>
        <div id="gauge-fuel-${cfg.prefix}" class="gauge"></div>
      </div>
      <div class="list">
        <ul>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('loan.meeting.currentKilometers')}</div>
              <div class="item-input-wrap">
                <input id="${cfg.prefix}-fuel-level" name="${cfg.upperSuffix}FuelLevel" type="hidden" value="${currentFuelLevel}" /> 
                <input id="${cfg.prefix}-kilometers" name="${cfg.upperSuffix}Kilometers" type="number" autocomplete="off" placeholder="${locale.translate('loan.meeting.currentKilometers')}"
                  value="${currentKilometers}" @input="${updateKilometers}" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </form>
    ${!isDisabled && props.data.CarLoanData.CarLoanStatusId == cfg.currentLoanStatusId ? $h`
    <div class="block block-strong">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a href="#" class="button button-small button-fill button-raised color-green" @click="${saveCarLoanImageList}">
            <span class="material-symbols-outlined">save</span>${locale.translate('general.accept')}
          </a>
        </div>
        <div></div>
      </p>
    </div>
    ` : $h`
    <span></span>
    `}
  </div>
</div>
`
    }
    ;
};
export default MeetingTab;